import { Container, Sprite } from '../../../odie';

import { CandyBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-------------------------------------------------------------------------
const manifest = {
  image: 'candy/block.candy.png',
};

/*
    candy block view
*/
export class CandyBlockView extends Container {
  public sprite: Sprite;
  // init
  //-------------------------------------------------------------------------
  constructor(props: CandyBlockProps) {
    // create base view
    super();
    this.sprite = new FitWidthBlockSprite(manifest.image, props);
    this.addChild(this.sprite);
    blockPositionView(this, props);
    this.y += 4;
  }

  public static assets(): string[] {
    return Object.values(manifest);
  }
}
